import {
  COLUMN_SUBDIVISIONS,
  getWidgetConstraints,
  initOptions,
} from '@/pages/landingPage/grid/widgetConstraints.ts';
import { assertTwoColumnWidgetLayoutConfigInDev } from '@/utils/twoColumnWidgetLayout/assertTwoColumnWidgetLayoutConfigInDev.ts';
import { BIOMASS_COMPONENT_NAME } from '@/widgetComponentNames.ts';

// Limits are in fine columns, so they scale with COLUMN_SUBDIVISIONS like every other width.
export const BIOMASS_TWO_COLUMN_WIDGET_LAYOUT = {
  firstChildLowerWidthLimit: 3 * COLUMN_SUBDIVISIONS,
  firstChildUpperWidthLimit: 5 * COLUMN_SUBDIVISIONS,
  firstChildWidth: 2 * COLUMN_SUBDIVISIONS,
} as const;

const biomassWidgetConstraints = getWidgetConstraints(BIOMASS_COMPONENT_NAME);
const biomassMinColumns = biomassWidgetConstraints.minW ?? 1;
const gridColumnCount = typeof initOptions.column === 'number' ? initOptions.column : 12;
const biomassMaxColumns = biomassWidgetConstraints.maxW ?? gridColumnCount;

assertTwoColumnWidgetLayoutConfigInDev(
  {
    firstChildLowerWidthLimit: BIOMASS_TWO_COLUMN_WIDGET_LAYOUT.firstChildLowerWidthLimit,
    firstChildUpperWidthLimit: BIOMASS_TWO_COLUMN_WIDGET_LAYOUT.firstChildUpperWidthLimit,
  },
  { min: biomassMinColumns, max: biomassMaxColumns }
);
